import { Avatar, Box, Icon, IconButton, MenuItem, Select, Tab, Tabs, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { INFO, ORDERS, RFQ } from '../Routes/constURL';
import Styles from '../Config/Styles';
import { storage } from '../Config/Storage';
import { useDispatch, useSelector } from 'react-redux';
import { uploadImage, users } from '../Redux/User/action';
import Loader from '../Components/Loader';
import Toastify from '../Components/Toastify';
import { statuses, value } from '../Redux/Mycart/action';

const dropdown = [{ name: "In Process", value: "in-process" }, { name: "Partially Delivered", value: "partially_delivered" },
{ name: "Delivered", value: "delivered" }, { name: "Exchanged", value: "exchanged" }, { name: "Partially Returned", value: "partially_returned" },
{ name: "Returned", value: "returned" }, { name: "Cancelled", value: "cancelled" }, { name: "Partially Delivered & Closed", value: "partial_return_closed" }]
const tabs = [
  "My Information", "Orders", "RFQ's"
]


const Profile = () => {
  const { userData } = useSelector((state) => state?.userData) || [];
  const { Statuses } = useSelector((state) => state?.CartData) || [];
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  // Refs for file inputs
  const bgRef = useRef(null);
  const avatarInputRef = useRef(null);
  const bgInputRef = useRef(null);

  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState("")

  let fileURL = ''

  useEffect(() => {
    if (!userData) {
      const user_id = storage.fetch.phone()
      dispatch(users(user_id, setLoading))
      dispatch(statuses())
    }
  }, [])

  useEffect(() => {
    setUser(userData?.data)

    setTabIndex(location.pathname === RFQ ? 2 : location.pathname === ORDERS ? 1 : 0)
  }, [userData, Statuses])

  useEffect(() => {

  }, [fileURL])



  // Handlers for avatar and background image upload
  const handleAvatarClick = (event) => {
    event.stopPropagation(); // Prevent propagation to the background box
    avatarInputRef.current.click();
  };

  const handleBgClick = () => {
    bgInputRef.current.click();
  };

  const handleFileChange = (event, type) => {
    setLoading(true)
    const file = event.target.files[0];
    let file_id
    if (file) {
      let formData = new FormData();
      if (type === "avatar") {
        file_id = user?.avatar
        formData.append('folder', 'c5966b2f-11dc-44d5-a273-de155ae10e92');
      } else {
        file_id = user?.bg_img
        formData.append('folder', '8dfddd7c-bd9b-48cb-9dde-b40c37f1a49f');
        fileURL = URL.createObjectURL(file);
        bgRef.current.style.backgroundImage = `url(${fileURL})`

      }

      formData.append('file', file || null);
      if (file_id)
        dispatch(uploadImage(formData, file_id, setLoading))
      else
        dispatch(uploadImage(formData, undefined, setLoading))
    }

  }

  const handleChange = (e) => {
    setLoading(true)
    dispatch(value(e.target.value === "Open" ? null : e.target.value))
    setTimeout(() => {
      setLoading(false)
    }, 2000);
  }


  const handleTabChange = (event, newIndex) => {
    if (newIndex === 2) {
      navigate(RFQ)
    } else if (newIndex === 1) {
      navigate(ORDERS)
    } else {
      navigate(INFO)
    }
    setTabIndex(newIndex);
  };

  return (
    <Box sx={Styles.profileStyle().outerbox}>
      <Loader open={loading} />
      <IconButton onClick={handleAvatarClick} sx={Styles.profileStyle().icon}>
        <Avatar sx={Styles.profileStyle().avatar}>
          <img
            src={userData?.data?.avatar ? `https://api-dev.tabta.net/assets/${userData?.data?.avatar}/?key=system-medium-cover` : require('../assets/user.png')}
            width={"70px"}
          />
        </Avatar>
      </IconButton>
      {/* Avatar Image Select Input */}
      <input
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        ref={avatarInputRef}
        onChange={(e) => handleFileChange(e, "avatar")}
      />
      <Box
        ref={bgRef}
        sx={{
          ...Styles.profileStyle().imagebox,
          backgroundImage: `url(${fileURL || `https://api-dev.tabta.net/assets/${userData?.data?.bg_img}/?key=system-medium-cover`})`,
        }}
        className="refresh-bg"
        onClick={handleBgClick}>

        <input
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          ref={bgInputRef}
          onChange={(e) => handleFileChange(e, "background")}
        />

        <Box sx={Styles.profileStyle().name}>
          <Typography variant="h6" sx={{fontWeight:600}} >
            {user?.first_name && user?.first_name}
          </Typography>
          <Typography variant="body2" sx={Styles.profileStyle.desc}>
            Buyer
          </Typography>
        </Box>
      </Box>
      <Toastify />
      <Loader open={loading} />
      <Box sx={{ ...Styles.profileStyle().tabs, display: { xs: "block", sm: "flex" }, justifyContent: "space-between", alignItems: "center" }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          sx={Styles.profileStyle().tabactive}
        >
          {tabs.map((item, index) =>
            <Tab key={index} label={item} sx={Styles.profileStyle().tab} />
          )}
        </Tabs>
        {location.pathname === ORDERS &&
          <Box sx={Styles.profileStyle().statusbox}>
            <Select
              defaultValue={"Open"}
              aria-placeholder='Open'
              onChange={handleChange}
              sx={Styles.profileStyle().status}>
              <MenuItem value="Open">Open</MenuItem>
              {Statuses?.map((item) =>
                <MenuItem value={item.id}>
                  {item.name}
                </MenuItem>
              )}
            </Select>
          </Box>
        }
      </Box>
      <Box sx={{ ...Styles.profileStyle().tabs, borderRadius: "0px 0px 10px 10px" }}>
        <Outlet />
      </Box>

    </Box>
  )
}

export default Profile